
class VideoPlayer extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            button: this.querySelector('[js-five-senses-carousel="button"]'),
            video: this.querySelector('[js-video-player="video"]')
        },
        this.elements.button.addEventListener("click", this.playVideo.bind(this));
        this.elements.video.addEventListener("play", this.changeButton.bind(this));
        this.elements.video.addEventListener("pause", this.changeButton.bind(this));
    }
    playVideo() {
        var _this = this;
        if (document.querySelectorAll('video').length) {
            document.querySelectorAll('video').forEach(function(vid) {
                if (vid != _this.elements.video) {
                    //vid.pause();
                }
            });
        }
        if (this.elements.video.paused) {
            this.elements.video.play();
        } else {
            this.elements.video.pause();
        }
    }
    changeButton() {
        if (this.elements.video.paused) {
            this.elements.button.classList.remove('is-active');
        } else {
            this.elements.button.classList.add('is-active');
        }
    }
}
customElements.define("video-player", VideoPlayer);
class SwiperSlider extends HTMLElement {
    constructor() {
        super();
        this.element = this.querySelector('[js-five-senses-carousel="container"]');
        this.navigation = this.querySelector('[js-five-senses-carousel="navigation"]');
        this.pagination = this.querySelector('[js-five-senses-carousel="pagination"]');
        var _this = this;
        if(typeof Swiper !== 'function') {
            // Create a script element
            const script = document.createElement('script');

            // Set the source to the Swiper CDN
            script.src = "https://cdn.jsdelivr.net/npm/swiper@6/swiper-bundle.min.js";

            // Optional: Set the type attribute
            script.type = "text/javascript";

            // Optional: Add an onload callback to initialize Swiper after the script is loaded
            script.onload = () => {
                this.initSlider(); // Call initSlider once Swiper is loaded
            };

            // Append the script to the head or body
            document.head.appendChild(script); // Or document.body.appendChild(script);

        } else {
            this.initSlider()
        }
    }
    initSlider() {
        const nextEl = this.navigation?.querySelector('.swiper-button-next') || '.swiper-button-next';
        const prevEl = this.navigation?.querySelector('.swiper-button-prev') || '.swiper-button-prev';

        var length = this.querySelectorAll('[js-five-senses-carousel="cell"]').length;
        const oldOptions = {
            a11y: { enabled: !0 },
            aria: !0,
            centeredSlides: !0,
            keyboard: { enabled: !0, onlyInViewport: !0 },
            mousewheel: { forceToAxis: !0 },
            loop: !0,
            loopedSlides: length,
            pagination: { el: this.pagination, type: "bullets", clickable: !0 },
            preventInteractionOnTransition: !0,
            slidesPerView: 1.5,
            spaceBetween: 16,
            watchSlidesVisibility: !0,
            navigation: { nextEl: nextEl, prevEl: prevEl },
            on: {
                slideChange: () => {
                    if (this.swiperInstance) {
                        this.pauseAllVideos();
                    }
                },
            },
            breakpoints: { 500: { slidesPerView: 3 }, 1024: { slidesPerView: 4 }, 1360: { slidesPerView: 5,centeredSlides: false } },
        };
        this.swiperInstance = new Swiper(this.element, oldOptions);

    }

    // Method to pause all videos except the active one
    pauseAllVideos() {
        const videos = this.element.querySelectorAll('video'); // Select all video elements
        const activeIndex = this.swiperInstance.realIndex; // Get the active slide index

        videos.forEach((video, index) => {
            // Pause all other videos
            video.pause();
        });
    }
}
customElements.define("swiper-slider", SwiperSlider);




if (document.querySelector('.animation-logo-top') && document.querySelector('.animation-logo-bottom')){
    // Create a script element
    const gsapscript = document.createElement('script');

    // Set the source to the Swiper CDN
    gsapscript.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.1/gsap.min.js";

    // Optional: Set the type attribute
    gsapscript.type = "text/javascript";

    // Optional: Add an onload callback to initialize Swiper after the script is loaded
    gsapscript.onload = () => {
        window.initScrollTrigger();
    };

    // Append the script to the head or body
    document.head.appendChild(gsapscript); // Or document.body.appendChild(script);
}

window.initScrollTrigger = function() {
    // Create a script element
    const stscript = document.createElement('script');

    // Set the source to the Swiper CDN
    stscript.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.1/ScrollTrigger.min.js";

    // Optional: Set the type attribute
    stscript.type = "text/javascript";

    // Optional: Add an onload callback to initialize Swiper after the script is loaded
    stscript.onload = () => {
        window.initGsap();
    };

    // Append the script to the head or body
    document.head.appendChild(stscript); // Or document.body.appendChild(script);
}

window.initGsap = function() {
        window.initGSAPOnSection();
}
window.GSAPINIT = false;
window.initGSAPOnSection = function() {
    setTimeout(function() {
        console.log(document.getElementById('shop-good-chemistry').scrollHeight)
        var down = window.innerHeight / 2 ;
        gsap.registerPlugin(ScrollTrigger);
        gsap.to('[data-section-id="1559665449425"] .animation-logo-top img', {
          scrollTrigger: {
            trigger: document.querySelector('.animation-logo-top').closest('.shopify-section'), // Use the section to trigger the animation
            start: "top center", // Trigger when the top of the section reaches the center of the viewport
            end: document.querySelector('.animation-logo-bottom').closest('.shopify-section').offsetTop - document.querySelector('.animation-logo-top').closest('.shopify-section').offsetTop - window.outerHeight + (document.querySelector('.animation-logo-top').closest('.shopify-section').offsetTop - window.outerHeight / 2) + "px", // End when the top of .end-section reaches the center of the viewport
            scrub: true, // Smooth link between scroll and animation
            pin: '[data-section-id="1559665449425"] .animation-logo-top img', // Pin the element itself (not the section)
            pinSpacing: false, // Ensure no extra space is added while the element is pinned
            onEnter: () => gsap.set('[data-section-id="1559665449425"] .animation-logo-top img', { opacity: 1 }), // Show the element on enter
            onLeave: () => gsap.set('[data-section-id="1559665449425"] .animation-logo-top img', { opacity: 0 }), // Hide the element on leave
            onLeaveBack: () => gsap.set('[data-section-id="1559665449425"] .animation-logo-top img', { opacity: 1 }), // Show the element when scrolling back
            onEnterBack: () => gsap.set('[data-section-id="1559665449425"] .animation-logo-top img', { opacity: 1 }), // Show the element when scrolling back up
          },
          y: down - 116, // Move 150px down
          rotation: 360
        });
        window.GSAPINIT = true;
    }, 1500)
}

// Listen for changes in the document height (resize or content added)
// window.addEventListener('resize', () => {
//   if ($('.pairings-product__slider').length > 0) {
//       setTimeout(function(e) {
       
//         if($(window).width() > 767){
//            var max_hight = 0
//         $('.pairings-product__slider .template-product__pairings-product-card .related-product__text-wrapper').each(function(e) {
//            var height = $(this).find('a').height()+$(this).find('form').height();
//            if(max_hight < height){
//               max_hight = height; 
//            } 
//         })
//         $('.pairings-product__slider .flickity-viewport').attr('style','height:'+max_hight+'px');
//         }else{
//           // var max_hight = 0
//           // $('.pairings-product__slider .template-product__pairings-product-card .related-product__text-wrapper').each(function(e) {
//           //    var height = $(this).height();
//           //    if(max_hight < height){
//           //       max_hight = height; 
//           //    } 
//           // })
//           // $('.pairings-product__slider .flickity-viewport').attr('style','height:'+max_hight+'px');
//         }    
        
    
//       },800);
//       $('.pairings-product__slider .flickity-viewport').attr('style','height:'+max_hight+'px');
//     }
//     if (window.GSAPINIT) {
//         ScrollTrigger.refresh(); // Refresh ScrollTrigger on resize
//     }
// });

if (typeof Swiper == 'function') {
  var swiper = new Swiper('.press-ticker-slider', {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 3000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView:'auto',
    allowTouchMove: false,
    disableOnInteraction: true
  });

  var swiper = new Swiper('.icons-ticker-slider', {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 3000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView:'auto',
    allowTouchMove: false,
    disableOnInteraction: true
  });

  var swiper = new Swiper('.review-ticker-slider', {
    slidesPerView: 'auto',
    spaceBetween:0,
     speed: 3000,
    grabCursor: true,
       autoplay: {
      delay: 1,
    },
    loop: true,
    observer: true,
    freeMode: false,  
    observeParents: true,
    navigation: {
      nextEl:'.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.slider__pagination',
      clickable: true,
    }, 
    keyboard: {
      enabled: true,
    },
  });
}



    $(".five-senses-carousel__slide video-player .ctm_mute_btn").click(function(){
    if($(this).hasClass("active")){
        $(this).removeClass("active");
        $(this).parents(".five-senses-carousel__slide").find("video").prop('muted', true);
    }else{
        $(this).addClass("active");
        $(this).parents(".five-senses-carousel__slide").find("video").prop('muted', false);
        $(this).parents(".five-senses-carousel__slide").siblings().find(".ctm_mute_btn").removeClass("active");
        $(this).parents(".five-senses-carousel__slide").siblings().find("video").prop('muted', true);
    }
});
